"use client";
/* eslint-disable react/prop-types */

import { Input } from "@/components/new/input";
import type { FieldErrors, UseFormRegister } from "react-hook-form";
import type { TProductReviewForm } from "@/types/product";
import ProfilePicture from "@/components/common/profile-picture";
import { TCustomUserSession } from "@/types/app";
import { Label } from "@/components/ui";
import { formatImageUrl } from "@/lib/utils";

interface UserDetailsSectionProps {
	register: UseFormRegister<TProductReviewForm>;
	errors: FieldErrors<TProductReviewForm>;
	user: TCustomUserSession | null | undefined;
}

export const UserDetailsSection: React.FC<UserDetailsSectionProps> = ({
	register,
	errors,
	user,
}) => {
	return (
		<div className="space-y-4">
			<h3 className="text-lg font-semibold text-gray-800">Your Details</h3>

			<div className="flex flex-col gap-6 md:flex-row md:items-center">
				<div className="flex justify-center md:items-center ">
					<ProfilePicture
						profilePictureUrl={formatImageUrl(user?.image) || ""}
						alternateText={user?.name || "User"}
						className={{
							container: "h-20 w-20 rounded-full",
							image: "rounded-full object-cover",
							badgeImage: "absolute -bottom-6 left-1/2 z-10 h-12 w-12 -translate-x-1/2",
						}}
						isVerified={user?.isVerified}
						isFounder={user?.isFounder}
					/>
				</div>

				<div className="grid w-full gap-y-4 md:grid-cols-2 md:gap-6">
					<div className="space-y-1">
						<Label className="text-sm text-gray-700">Name</Label>
						<Input
							value={user?.name || ""}
							disabled
							aria-disabled="true"
							className="rounded-md bg-gray-100 text-sm font-medium"
						/>
					</div>

					<div className="space-y-1">
						<Label className="text-sm text-gray-700">Job Title</Label>
						<Input
							placeholder="Job Title"
							{...register("reviewerDesignation.jobTitle")}
							className="rounded-md text-sm"
						/>
						{errors.reviewerDesignation?.jobTitle && (
							<p className="text-xs text-red-500">
								{String(errors.reviewerDesignation.jobTitle.message)}
							</p>
						)}
					</div>

					<div className="space-y-1">
						<Label className="text-sm text-gray-700">Company Name</Label>
						<Input
							placeholder="Company Name"
							{...register("reviewerDesignation.companyName")}
							className="rounded-md text-sm"
						/>
						{errors.reviewerDesignation?.companyName && (
							<p className="text-xs text-red-500">
								{String(errors.reviewerDesignation.companyName.message)}
							</p>
						)}
					</div>

					<div className="space-y-1">
						<Label className="text-sm text-gray-700">Company Website</Label>
						<Input
							placeholder="Company Website"
							{...register("reviewerDesignation.companyWebsite")}
							className="rounded-md text-sm"
						/>
						{errors.reviewerDesignation?.companyWebsite && (
							<p className="text-xs text-red-500">
								{String(errors.reviewerDesignation.companyWebsite.message)}
							</p>
						)}
					</div>

					<div className="space-y-1">
						<Label className="text-sm text-gray-700">Linkedin</Label>
						<Input
							type="url"
							placeholder="https://linkedin.com/in/username"
							{...register("reviewerDesignation.linkedin")}
							className="rounded-md text-sm"
						/>
						{errors.reviewerDesignation?.linkedin && (
							<p className="text-xs text-red-500">
								{String(errors.reviewerDesignation.linkedin.message)}
							</p>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};
